module.exports = __webpack_public_path__ + "media/home-r.300c699f.mp4";